import { useLayoutEffect, useRef, useState } from "react";

type MediaImageProps = {
  src: string;
  alt: string;
  className?: string;
  eager?: boolean;
  fade?: boolean;
  layout?: "fill" | "frame" | "natural";
  objectPosition?: string;
};

export function MediaImage({
  src,
  alt,
  className = "",
  eager = false,
  fade = true,
  layout = "fill",
  objectPosition,
}: MediaImageProps) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [status, setStatus] = useState<"loading" | "ready" | "error">("loading");

  useLayoutEffect(() => {
    const image = imageRef.current;
    if (image?.complete && image.naturalWidth > 0) {
      setStatus("ready");
      return;
    }
    setStatus("loading");
  }, [src]);

  return (
    <span className={`media-image is-${layout} is-${status}${fade ? "" : " is-instant"} ${className}`.trim()} aria-busy={status === "loading"}>
      {status !== "error" ? <span className="media-image-skeleton" aria-hidden="true" /> : null}
      {status === "error" ? (
        <span className="media-image-fallback" aria-hidden="true" />
      ) : (
        <img
          ref={imageRef}
          src={src}
          alt={alt}
          loading={eager ? "eager" : "lazy"}
          decoding={eager ? "sync" : "async"}
          fetchPriority={eager ? "high" : "low"}
          draggable={false}
          style={objectPosition ? { objectPosition } : undefined}
          onLoad={() => setStatus("ready")}
          onError={() => setStatus("error")}
        />
      )}
    </span>
  );
}
